import { render, staticRenderFns } from "./vendorAssess.vue?vue&type=template&id=b3d6c286"
import script from "./vendorAssess.vue?vue&type=script&lang=js"
export * from "./vendorAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3d6c286')) {
      api.createRecord('b3d6c286', component.options)
    } else {
      api.reload('b3d6c286', component.options)
    }
    module.hot.accept("./vendorAssess.vue?vue&type=template&id=b3d6c286", function () {
      api.rerender('b3d6c286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorAssess.vue"
export default component.exports